import { render, staticRenderFns } from "./offerTable.vue?vue&type=template&id=4076a6ce&scoped=true&"
import script from "./offerTable.vue?vue&type=script&lang=js&"
export * from "./offerTable.vue?vue&type=script&lang=js&"
import style0 from "./offerTable.vue?vue&type=style&index=0&lang=css&"
import style1 from "../statistics/css/finance.css?vue&type=style&index=1&id=4076a6ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4076a6ce",
  null
  
)

export default component.exports